import { Button } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../../context/auth';
import { useContextNotifications } from '../../../../context/notifications';

type Props = {
  userEmail: string;
}

const ResendVerificationEmailButton: FC<Props> = ({ userEmail }) => {
  const { resendVerificationEmail, loading } = useAuth();
  const [timer, setTimer] = useState<number>(30);
  const { openNotification } = useContextNotifications();

  useEffect(() => {
    if (timer === 0) return;

    const intervalId = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(intervalId);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(intervalId);
  }, [timer]);

  const handleResendEmail = useCallback(async () => {
    if (!userEmail) {
      openNotification?.({ message: 'No email available for resend.', type: 'error' });

      return;
    }

    setTimer(30)

    try {
      await resendVerificationEmail(userEmail)
      openNotification?.({ message: 'Verification email sent successfully!', type: 'success' });
    } catch (error: any) {
      openNotification?.({ message: `Error sending email: ${error?.message || error}`, type: 'error' });
    }
  }, [userEmail])

  return (
    <Button
      size="large"
      type="primary"
      block
      disabled={timer > 0}
      loading={loading}
      onClick={handleResendEmail}
    >
      {timer > 0 ? (
        <>
          Resend in <strong>{timer}s</strong>
        </>
      ) : 'Resend Verification Email'}
    </Button>
  )
}

export default ResendVerificationEmailButton;
